// extracted by mini-css-extract-plugin
export var black = "_47-6";
export var brand = "_47-1";
export var ddefault = "_47-0";
export var error = "_47-3";
export var gray = "_47-2";
export var highContrast = "_47-8";
export var outline = "_47-7";
export var success = "_47-5";
export var warning = "_47-4";